<template>
  <div class="container sub-page">
    <div class="sub-page">
      <div class="shop-row">
        <span>淘宝地址</span>
        <cube-input v-model="changeData.tmallUrl" placeholder="淘宝地址" style></cube-input>
      </div>
      <div class="shop-row">
        <span>京东地址</span>
        <cube-input v-model="changeData.jdUrl" placeholder="京东地址" style></cube-input>
      </div>
      <div class="shop-row">
        <span>惠农地址</span>
        <cube-input v-model="changeData.hnUrl" placeholder="惠农地址" style></cube-input>
      </div>
      <div class="shop-row" style="padding-top: 30px;">
        <button class="my-btn" @click="change()">确定</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios"; // 引入axios
import { getCitys } from "@/api/bapi";
import { addUser2 } from "@/api/bapi";
import { getOrgDetail } from "@/api/bapi";
export default {
  name: "Store",
  data() {
    return {
      obj: {
        tb: "",
        jd: "",
        hn: ""
      },
      subT: "",
      subTitle: this.$route.meta.subTitle,
      changeData: {}
    };
  },
  watch: {
    $route(to, from) {
      if (/\/Store/gi.test(to.path)) {
        this.getInfo();
      }
    }
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      let userInfo = JSON.parse(localStorage.getItem("loginUserInfo"));
      this.getChangeData(userInfo.sysUser.orgId);
    },
    getChangeData(id) {
      getOrgDetail(id)
        .then(res => {
          this.changeData = res.data.data;
        })
        .catch(function(reason) {
          this.$Message.error("您暂无权限");
        });
    },
    changeHandler(label) {
      if (label == "我的") {
        this.$router.push({ path: "Center" });
      } else {
        this.$router.push({ path: "Index" });
      }
    },
    erroruShow(msg) {
      this.$Message.error(msg);
      setTimeout(() => {
        this.changeMd = false;
        this.$nextTick(() => {
          this.changeMd = true;
        });
      }, 100);
    },
    //修改信息
    change() {
      let uer = JSON.stringify(this.changeData);
      addUser2(uer)
        .then(res => {
          if (res.status == 200) {
            if (res.data.code == 0) {
              this.$Message.success("修改成功！");
            } else {
              this.erroruShow(res.data.msg);
            }
          }
        })
        .catch(function(reason) {});
    }
  }
};
</script>

<style scoped>
.photo {
  width: 30%;
}
.photo img {
  width: 100%;
}
h3 {
  font-size: 1.4rem;
  font-weight: bold;
  margin-top: 5px;
}
.list {
  width: 100%;
  margin: 20px auto 0;
  text-align: left;
}
.list li {
  padding: 20px;
  background-color: white;
  border-bottom: 1px solid rgb(222, 221, 221);
}
.ic {
  float: right;
}
.bt {
  width: 40%;
  margin: 0px auto;
  height: 45px;
  line-height: 45px;
  border-radius: 6px;
  text-align: center;
  font-size: 0.8rem;
  color: white;
  background-color: #fc9153;
}
.add {
  width: 100px;
  padding: 10px 20px;
  text-align: center;
  float: right;
  color: white;
  background-color: #fc9153;
}
</style>

<style lang="scss" scoped>
@import "../assets/css/rem.scss";
.shop-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: rem(30);
  span {
    margin-right: 12px;
  }
  .cube-input {
    flex: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Store.vue